import { useState } from "react"
import { useParams } from "react-router-dom"
import { useApiService } from "../hooks/Api/useApiService"
import { Box, Button, Card, CardContent, TextField, Typography } from "@mui/material"
import srp from "secure-remote-password/client"

export default function ResetPasswordPage() {
  const { token } = useParams()
  const [password, setPassword] = useState("")
  const [confirm_password, setConfirmPassword] = useState("")
  const { BASE_URL } = useApiService()

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (password !== confirm_password) {
      alert("Passwords don't match!")
      return
    }
    if (!password || !confirm_password) {
      alert("You must fill all fields.")
      return
    }
    const username = localStorage.getItem("user")
    const salt = srp.generateSalt()
    const privateKey = await srp.derivePrivateKey(salt, username, password)
    const verifier = await srp.deriveVerifier(privateKey)

    const res = await fetch(BASE_URL + `users/reset-password/${token}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ salt, verifier, username }),
      credentials: "include", // optional, for cookies
    })

    if (res.ok) {
      alert("Password reset! You can now login.")
      window.location.href = "/"
    } else {
      alert("Failed to reset password.")
    }
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#e3f2fd", // Light blue background
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", p: 2 }}>
        <CardContent>
          <Typography variant='h5' component='h1' gutterBottom align='center' color='primary'>
            Reset Your Password
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              type='password'
              label='New Password'
              variant='outlined'
              fullWidth
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              type='password'
              label='Confirm Password'
              variant='outlined'
              fullWidth
              value={confirm_password}
              onChange={(e) => setConfirmPassword(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
            <Button type='submit' variant='contained' color='primary' fullWidth sx={{ py: 1.5 }}>
              Reset Password
            </Button>
          </form>
        </CardContent>
      </Card>
    </Box>
  )
}
